module.exports = __webpack_public_path__ + "img/a730e43.png";